export const guideForSceneConfig = {
  guideContentConfig: {
    topArea: {
      title: [
        {
          type: 'dynamic',
          value: 'amount',
          style: {
            color: '#FDD874',
            fontSize: '',
            textShadow: '0px 1px 5px rgba(218, 70, 72, 0.36)'
          }
        },
        {
          type: 'static',
          value: '元',
          style: {
            color: '#FDD874',
            fontSize: '',
            textShadow: '0px 1px 5px rgba(218, 70, 72, 0.36)'
          }
        },
        {
          type: 'static',
          value: '红包发放至',
          style: {
            color: '',
            fontSize: '',
            textShadow: '0px 1px 5px rgba(218, 70, 72, 0.36)'
          }
        }
      ],
      subTitle: [
        {
          type: 'static',
          value: '【数字人民币App-',
          style: {
            color: '',
            fontSize: '',
            textShadow: '0px 1px 2px rgba(255, 58, 76, 0.69)'
          }
        },
        {
          type: 'dynamic',
          value: 'bank_name',
          style: {
            color: '#FDD874',
            fontSize: '',
            textShadow: '0px 1px 2px rgba(255, 58, 76, 0.69)'
          }
        },
        {
          type: 'static',
          value: '钱包',
          style: {
            color: '#FDD874',
            fontSize: '',
            textShadow: '0px 1px 2px rgba(255, 58, 76, 0.69)'
          }
        },
        {
          type: 'static',
          value: '】',
          style: {
            color: '',
            fontSize: '',
            textShadow: '0px 1px 2px rgba(255, 58, 76, 0.69)'
          }
        }
      ],
      tip: [
        {
          type: 'static',
          value: '请参照',
          style: {
            color: '',
            fontSize: ''
          }
        },
        {
          type: 'static',
          value: '下列步骤',
          style: {
            color: '#FDD874',
            fontSize: ''
          }
        },
        {
          type: 'static',
          value: '查看并使用奖励',
          style: {
            color: '',
            fontSize: ''
          }
        }
      ]
    },
    module: [
      {
        type: 'jump2download',
        downloadTitle: '下载并登录数字人民币App',
        openTitle: '打开并登录数字人民币App',
        subTitle: [
          {
            type: 'static',
            value: '请使用',
            style: {
              color: '',
              fontSize: ''
            }
          },
          {
            type: 'dynamic',
            value: 'mobile_mask',
            style: {
              color: '#B31A2F',
              fontSize: ''
            }
          },
          {
            type: 'static',
            value: '登录',
            style: {
              color: '',
              fontSize: ''
            }
          }
        ],
        downLoadArea: {
          downloadTipIphone: [],
          downloadTipAndroid: [],
          downloadFailTip: [
            {
              text: '下载存在异常，请联系客服（95172-5-5）后重新下载',
              style: {
                color: 'rgba(255,62,51,0.90)'
              }
            }
          ],
          downloadTip: [
            {
              text: '中国人民银行官方发行的试点版App',
              style: {
                fontSize: '0.24rem'
              },
              component: 'guide1'
            },
            {
              text: '中国人民银行官方发行的试点版App',
              style: {
                fontSize: '0.24rem'
              },
              component: 'guide2'
            },
            {
              text: '在数字人民币App中开通邮储钱包，推送美团子钱包即可查看和使用红包',
              style: {
                fontSize: '0.28rem'
              },
              component: 'simpleness'
            }
          ],
          btnTextDownload: '立即下载',
          btnTextOpen: '去查看',
          tip: ''
        }
      },
      {
        type: 'single',
        isOpenBank: true,
        title: [
          {
            type: 'static',
            value: '开通'
          },
          {
            type: 'dynamic',
            value: 'bank_name'
          },
          {
            type: 'static',
            value: '钱包'
          }
        ],
        subTitle: [
          {
            type: 'static',
            value: '在数字人民币App完成开通后查看奖励'
          }
        ],
        bankType: {
          403: {
            imgConfig: [
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-2-1.png',
                text: '1.“我的”页点击“开通或添加数字钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-2-2.png',
                text: '2.选择“邮储银行”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-2-3.png',
                text: '3.设置联系方式'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-2-4.png',
                text: '4.数字钱包开通成功'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-2-5.png',
                text: '5.数字人民币到账'
              }
            ]
          },
          404: {
            imgConfig: [
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-2-1.png',
                text: '1.“我的”页点击“开通或添加数字钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-2-2.png',
                text: '2.选择“农业银行”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-2-3.png',
                text: '3.设置联系方式'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-2-4.png',
                text: '4.数字钱包开通成功'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-2-5.png',
                text: '5.数字人民币到账'
              }
            ]
          },
          405: {
            imgConfig: [
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianshe-2-1.png',
                text: '1.“我的”页点击“开通或添加数字钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianshe-2-2.png',
                text: '2.选择“建设银行”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianshe-2-3.png',
                text: '3.设置联系方式'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianshe-2-4.png',
                text: '4.数字钱包开通成功'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianshe-2-5.png',
                text: '5.数字人民币到账'
              }
            ]
          }
        }
      },
      {
        type: 'single',
        title: [
          {
            type: 'static',
            value: '将子钱包推送至“美团App”'
          }
        ],
        subTitle: [
          {
            type: 'static',
            value: '在数字人民币App完成推送',
            style: {
              display: 'block'
            }
          },
          {
            type: 'static',
            value: '返回美团App参加瓜分活动，个人'
          },
          {
            type: 'static',
            value: '最高可得200元',
            style: {
              color: '#B31A2F',
              fontSize: ''
            }
          }
        ],
        bankType: {
          403: {
            imgConfig: [
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-3-1.png',
                text: '1.进入“服务”页点击“查看更多”按钮'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-3-2.png',
                text: '2.点击“添加子钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-3-3.png',
                text: '3.选择“美团”子钱包'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-3-4.png',
                text: '4.选择已开通的“邮储银行钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-3-5.png',
                text: '5.推送成功点击“打开美团”'
              },
              {
                url: '//s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/3-1-5-a.png',
                text: '6.点击“立即瓜分”按钮'
              }
            ]
          },
          404: {
            imgConfig: [
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-3-1.png',
                text: '1.进入“服务”页点击“查看更多”按钮'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-3-2.png',
                text: '2.点击“添加子钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-3-3.png',
                text: '3.选择“美团”子钱包'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-3-4.png',
                text: '4.选择已开通的“农业银行钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nongye-3-5.png',
                text: '5.推送成功点击“打开美团”'
              },
              {
                url: '//s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/3-1-5-a.png',
                text: '6.点击“立即瓜分”按钮'
              }
            ]
          },
          405: {
            imgConfig: [
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianhang-3-1.png',
                text: '1.进入“服务”页点击“查看更多”按钮'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianhang-3-2.png',
                text: '2.点击“添加子钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianhang-3-3.png',
                text: '3.选择“美团”子钱包'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianhang-3-4.png',
                text: '4.选择已开通的“建设银行钱包”'
              },
              {
                url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianhang-3-5.png',
                text: '5.推送成功点击“打开美团”'
              },
              {
                url: '//s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/3-1-5-a.png',
                text: '6.点击“立即瓜分”按钮'
              }
            ]
          }
        }
      },
      {
        type: 'multiple',
        title: '红包消费',
        'img-title-first': '1. 可以在支付骑行订单或者购买单车套餐时使用红包。',
        'imgConfig-first': [
          {
            url: '//s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:29bd8f2d/guide-costume-0730.png',
            width: '6.9rem',
            height: '18rem',
            text: ''
          }
        ],
        'img-title-second': '2. 若红包余额不足请先充值后再消费。',
        'imgConfig-second': {
          403: [
            {
              url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-4-1.png',
              text: '1.首页点击“充钱包”'
            },
            {
              url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-youchu-4-2.png',
              text: '2.输入充值金额'
            }
          ],
          404: [
            {
              url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nonghang-4-1.png',
              text: '1.首页点击“充钱包”'
            },
            {
              url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-nonghang-4-2.png',
              text: '2.输入充值金额'
            }
          ],
          405: [
            {
              url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianhang-4-1.png',
              text: '1.首页点击“充钱包”'
            },
            {
              url: '//s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/v2.0-jianhang-4-2.png',
              text: '2.输入充值金额'
            }
          ]
        }
      }
    ]
  },
  strategyConfig: {
    recallStrategys: [
      {
        name: 'justDownload',
        guide: [
          1,
          2,
          3
        ],
        title: '请您按照如下步骤，开通银行钱包、将子钱包推送至美团App、消费红包。'
      },
      {
        name: 'hasOpenWallet',
        guide: [
          2,
          3
        ],
        title: '请您按照如下步骤，将子钱包推送至美团App、消费红包。'
      },
      {
        name: 'hasPushWallet',
        guide: [
          3
        ],
        title: '请您按照如下攻略消费红包。'
      },
      {
        name: 'hasOpenBank',
        guide: [
          0,
          2,
          3
        ]
      }
    ]
  }
};
